import React, { memo } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import ListRole from "./ListRole";

const AddRoleModal = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  values,
  setting,
  onChange,
  onChangePermission,
  isChecked,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="xl"
      backdrop={true}
      autoFocus={false}
    >
      <Form onSubmit={(e) => onSubmit(e)}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="name" className="text-muted">
              <IntlMessages id="role.name" />
              <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              autoFocus={true}
              type="text"
              name="name"
              id="name"
              disabled={setting.viewonly && !setting.add}
              value={values.name}
              onChange={onChange}
            />
          </FormGroup>
          <FormGroup>
            <ListRole
              settings={values.settings}
              onChangePermission={onChangePermission}
              isChecked={isChecked}
              disabled={setting.viewonly && !setting.add}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">
            <IntlMessages id="role.btn-add" />
          </Button>{" "}
          <Button color="secondary" type="button" onClick={toggle}>
            <IntlMessages id="general.btn-cancel" />
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default memo(AddRoleModal);
